import { LiveApp } from "./auth/LiveApp";

export default function App() {
  return <LiveApp />;
}
